let data = [{
		name: '海讯IM介绍',
		child: [{
			name: '海讯IM介绍',
			child: [{
				name: '海讯IM介绍',
				child: [{
					type: 'text',
					data: "<p>海讯IM，轻量级人工智能IM解决方案供应商。</p><p>海讯IM( http://shisay.im）作为浪鲸智能旗下即时通讯云PaaS平台核心产品，采用高可用的平台架构，满足多场景企业内外部实时通讯需求，兼容服务器端集成和客户端集成，真正做到安全、即时、高效，拥有卓越的可拓展性，提供人工智能技术赋能和安全保障，海讯IM以其强大的智能技术日趋成为AI+IM的智能时代卓越典范</p>"
				}]
			}]
		}, ]
	},
	{
		name: '海讯IM架构',
		child: [{
				name: '海讯IM架构原则',
				child: [{
					name: '海讯IM架构原则',
					child: [{
						type: 'text',
						data: '<p>（1）代码可复用性（对接多套系统）；</p><p>（2）服务高可用性（主从式部署）；</p><p>（3）服务高并发性能（分布式部署）；</p><p>（4）可拓展性（兼容多消息类型）；</p><p>（5）数据安全（客户服务器可选择性存储用户消息记录）。</p>'
					}]
				}]
			},
			{
				name: '海讯IM架构图解',
				child: [{
					name: '海讯IM架构图解',
					child: [{
							type: 'text',
							data: '<p>（1）模式一：服务器端集成能力收发消息架构（由服务器负责推送和处理消息）：</p>'
						},
						{
							type: 'img',
							data: require('../../src/assets/docu/d1.png')
						},
						{
							type: 'text',
							data: '<p>（2）模式二：客户端集成能力收发消息架构（由客户端负责推送和处理消息）：</p>'
						},
						{
							type: 'img',
							data: require('../../src/assets/docu/d2.png')
						},
					]
				}]
			},
		]
	},
	{
		name: '新手指引',
		child: [{
				name: '申请APPID和APPTOKEN',
				child: [{
					name: '申请APPID和APPTOKEN',
					child: [{
						type: 'text',
						data: '海讯IM内测阶段请开发者联系admin@yofea.com或者致电4006969956，以获得APPID和APPTOKEN及其相关帮助。'
					}]
				}]
			},
			{
				name: '配置消息回调等URL',
				child: [{
					name: '配置消息回调等URL',
					child: [{
						type: 'text',
						data: '如果您采用服务器端集成能力架构（模式一），您可下载并使用我们为您提供的后端SDK或者直接参见服务器端集成接口文档调用接口，从而方便快捷地使用我们的IM服务；如果您采用客户端集成能力架构（模式二），且您有在您自身的业务服务器中持久化消息的需求，那么您可登录后使用可视化的控制台配置您的消息回调地址和鉴权回调地址，配置回调URL后，您可参见文档或DEMO进行接口编写以处理海讯IM请求您所配置的URL事件。并且根据您的情况在后台设置应用状态（“禁用”、“启用并启用回调”或“启用并禁用回调”）。至此，您就可参阅接口文档进行调用和集成开发啦！'
					}]
				}]
			},
			{
				name: '鉴权及回调指引',
				child: [{
					name: '鉴权及回调指引',
					child: [{
						type: 'img',
						data: require('../../src/assets/docu/d3.png')
					}]
				}]
			},

		]
	},
	{
		name: '集成SDK下载及使用',
		child: [{
			name: '集成SDK下载及使用',
			child: [{
				name: '集成SDK下载及使用',
				child: [{
						type: 'text',
						data: '<a  href="https://hisay.im/PHPSDK.docx" style="color: #3A8EE6">PHP集成SDK下载</a>'
					},
					{
						type: 'text',
						data: '<a href="https://hisay.im/public/document.zip" style="color: #3A8EE6">PHP集成SDK接口文档下载</a>'
					},
					{
						type: 'text',
						data: '<a href="https://hisay.im/public/PHPSDK.zip" style="color: #3A8EE6">PHP集成和处理回调示例DEMO下载</a>'
					},
				]
			}]
		}, ]
	},
	{
		name: '客户端集成架构调用海讯IM接口',
		child: [{
				name: 'bind接口',
				child: [{
					name: 'bind接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '由uid、clientid完成绑定客户端ID'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/message/bind'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'clientid',
										info: '客户端ID'
									},
									{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 0,
										name: 'groupid',
										info: '用户已加入的群聊ID，多个则用英文逗号分隔'
									},
									{
										is: 0,
										name: 'friendid',
										info: '用户的好友ID列表，多个则用英文逗号分隔(允许白名单外用户收发消息时，此参数可不传)'
									},
									{
										is: 0,
										name: 'blacklistid',
										info: '用户的黑名单用户ID列表，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'sendMsg接口',
				child: [{
					name: 'sendMsg接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '客户端发送消息'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/message/sendMsg'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'msg',
										info: '消息文本(自定义文本格式)'
									},
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'toid',
										info: '接收人UID'
									},
									{
										is: 0,
										name: 'totype',
										info: '1 用户消息（默认） 2 群组消息'
									},
									{
										is: 1,
										name: 'oauth_token',
										info: 'oauth_token接口调用凭据'
									},
								],
							}
						},
					]
				}]
			},
		]
	},
	{
		name: '服务器端集成架构调用海讯IM接口',
		child: [{
				name: 'sendMsg接口',
				child: [{
					name: 'sendMsg接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '发送消息'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/sendMsg'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'msg',
										info: '消息文本(自定义文本格式)'
									},
									{
										is: 1,
										name: 'toid',
										info: '接收人UID'
									},
									{
										is: 0,
										name: 'totype',
										info: '1 用户消息（默认） 2 群组消息'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'joinGroup接口',
				child: [{
					name: 'joinGroup接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '加入群聊，先前已经加入过的群聊将被忽略'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/joinGroup'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'groupid',
										info: '群聊ID，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'leaveGroup接口',
				child: [{
					name: 'leaveGroup接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '执行用户退出群聊'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/leaveGroup'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'groupid',
										info: '群聊ID，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'ungroup接口',
				child: [{
					name: 'ungroup接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '根据群聊号（批量）解散群聊'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/ungroup'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'groupid',
										info: '群聊ID，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'addFriends接口',
				child: [{
					name: 'addFriends接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '为用户将新的好友添加到聊天好友列表'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/addFriends'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'friendid',
										info: '用户的好友ID列表，多个则用英文逗号分隔(本接口适用于不允许白名单外用户收发消息的场景)'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'removeFriends接口',
				child: [{
					name: 'removeFriends接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '为用户移除拟解除好友关系的聊天好友'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/removeFriends'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'friendid',
										info: '用户的好友ID列表，多个则用英文逗号分隔(本接口适用于不允许白名单外用户收发消息的场景)'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'addBlacklist接口',
				child: [{
					name: 'addBlacklist接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '为用户将新的黑名单用户添加到黑名单列表'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/addBlacklist'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'blacklistid',
										info: '用户的黑名单用户列表ID列表，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'removeBlacklist接口',
				child: [{
					name: 'removeBlacklist接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '为用户移除黑名单用户列表'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/removeBlacklist'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'blacklistid',
										info: '用户的黑名单用户列表ID列表，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'deleteUserOAuthToken接口',
				child: [{
					name: 'deleteUserOAuthToken接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{

										name: '接口简介',
										info: '删除用户OAuth认证信息'
									},
									{

										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/deleteUserOAuthToken'
									},
									{

										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'getOnlineCountByGroup接口',
				child: [{
					name: 'getOnlineCountByGroup接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{
			
										name: '接口简介',
										info: '获取在线人数'
									},
									{
			
										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/getOnlineCountByGroup'
									},
									{
			
										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
									{
										is: 1,
										name: 'groupid',
										info: '需要获取的群聊ID'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'fetchMissingMsg接口',
				child: [{
					name: 'fetchMissingMsg接口',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '接口信息',
										prop: 'info'
									}
								],
								row: [{
			
										name: '接口简介',
										info: '获取遗漏的消息记录'
									},
									{
			
										name: '接口地址',
										info: 'https://msg.yfcat.com/index/sysmessage/fetchMissingMsg'
									},
									{
			
										name: '请求方式',
										info: 'POST'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [{
										is: 1,
										name: 'appid',
										info: '应用ID'
									},
									{
										is: 1,
										name: 'timestamp',
										info: '生成签名的时间戳'
									},
									{
										is: 1,
										name: 'sign',
										info: '签名信息（由appid、timestamp、appToken生成）'
									},
								],
							}
						},
					]
				}]
			},
		]
	},

	{
		name: '服务器端集成SDK帮助文档',
		child: [{
				name: 'sendMsg方法',
				child: [{
					name: 'sendMsg方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '发送消息'
									},
									{

										name: '方法调用',
										info: 'ImClient::sendMsg($toId,$msg="",$toType=1)'
									},
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'msg',
										info: '消息文本(自定义文本格式)'
									},
									{
										is: 1,
										name: 'toid',
										info: '接收人UID'
									},
									{
										is: 0,
										name: 'totype',
										info: '1 用户消息（默认） 2 群组消息'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'joinGroup方法',
				child: [{
					name: 'joinGroup方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '加入群聊，先前已经加入过的群聊将被忽略'
									},
									{

										name: '方法调用',
										info: 'ImClient::joinGroup($uid,$groupId)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'groupid',
										info: '群聊ID，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'leaveGroup方法',
				child: [{
					name: 'leaveGroup方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '执行用户退出群聊'
									},
									{

										name: '方法调用',
										info: 'ImClient::leaveGroup($uid,$groupId)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'groupid',
										info: '群聊ID，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'ungroup方法',
				child: [{
					name: 'ungroup方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '根据群聊号（批量）解散群聊'
									},
									{

										name: '方法调用',
										info: 'ImClient::ungroup($groupId)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'groupid',
										info: '群聊ID，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'addFriends方法',
				child: [{
					name: 'addFriends方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '为用户将新的好友添加到聊天好友列表'
									},
									{

										name: '方法调用',
										info: 'ImClient::addFriends($uid,$friendId)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'friendid',
										info: '用户的好友ID列表，多个则用英文逗号分隔(本接口适用于不允许白名单外用户收发消息的场景)'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'removeFriends方法',
				child: [{
					name: 'removeFriends方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '为用户移除拟解除好友关系的聊天好友'
									},
									{

										name: '方法调用',
										info: 'ImClient::removeFriends'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'friendid',
										info: '用户的好友ID列表，多个则用英文逗号分隔(本接口适用于不允许白名单外用户收发消息的场景)'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'addBlacklist方法',
				child: [{
					name: 'addBlacklist方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '为用户将新的黑名单用户添加到黑名单列表'
									},
									{

										name: '方法调用',
										info: 'ImClient::addBlacklist($uid,$blacklistId)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'blacklistid',
										info: '用户的黑名单用户列表ID列表，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'removeBlacklist方法',
				child: [{
					name: 'removeBlacklist方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '为用户移除黑名单用户列表'
									},
									{

										name: '方法调用',
										info: 'ImClient::removeBlacklist($uid,$blacklistId)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
									{
										is: 1,
										name: 'blacklistid',
										info: '用户的黑名单用户列表ID列表，多个则用英文逗号分隔'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'deleteUserOAuthToken方法',
				child: [{
					name: 'deleteUserOAuthToken方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{

										name: '方法简介',
										info: '删除用户OAuth认证信息'
									},
									{

										name: '方法调用',
										info: 'ImClient::deleteUserOAuthToken($uid)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									{
										is: 1,
										name: 'uid',
										info: '用户id'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'getOnlineCountByGroup方法',
				child: [{
					name: 'getOnlineCountByGroup方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{
			
										name: '方法简介',
										info: '获取群聊在线人数'
									},
									{
			
										name: '方法调用',
										info: 'ImClient::getOnlineCountByGroup($timestamp,$sign)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									
									{
										is: 1,
										name: 'timestamp',
										info: '用户idIM服务器向客户端请求携带的timestamp参数'
									},
									{
										is: 1,
										name: 'sign',
										info: 'IM服务器向客户端请求携带的sign参数'
									},
									{
										is: 1,
										name: 'groupid',
										info: '群聊id'
									},
								],
							}
						},
					]
				}]
			},
			{
				name: 'checkSign方法',
				child: [{
					name: 'checkSign方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{
			
										name: '方法简介',
										info: '删除用户OAuth认证信息'
									},
									{
			
										name: '方法调用',
										info: 'ImClient::checkSign($timestamp,$sign)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									
									{
										is: 1,
										name: 'timestamp',
										info: '用户idIM服务器向客户端请求携带的timestamp参数'
									},
									{
										is: 1,
										name: 'sign',
										info: 'IM服务器向客户端请求携带的sign参数'
									},
									
								],
							}
						},
					]
				}]
			},
			{
				name: 'fetchMissingMsg方法',
				child: [{
					name: 'fetchMissingMsg方法',
					child: [{
							type: 'text',
							data: '（1）接口基本信息：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '名称',
										prop: 'name'
									},
									{
										label: '概述',
										prop: 'info'
									}
								],
								row: [{
			
										name: '方法简介',
										info: '获取遗漏的消息'
									},
									{
			
										name: '方法调用',
										info: 'ImClient::fetchMissingMsg($timestamp,$sign)'
									},
									
								],
							}
						},
						{
							type: 'text',
							data: '（2）请求参数说明：'
						},
						{
							type: 'table',
							data: {
								col: [{
										label: '参数',
										prop: 'name'
									},
									{
										label: '必填',
										prop: 'is'
									},
									{
										label: '参数描述',
										prop: 'info'
									}
								],
								row: [
									
									{
										is: 1,
										name: 'timestamp',
										info: '用户idIM服务器向客户端请求携带的timestamp参数'
									},
									{
										is: 1,
										name: 'sign',
										info: 'IM服务器向客户端请求携带的sign参数'
									},
									
								],
							}
						},
					]
				}]
			},
		]
	},

]
export default data
